var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'core', 'app-common/component/infinite-scrolling', 'app-common/component/loader', 'common/component/money-formatter', 'common/component/date-formatter', 'app-common/component/confirm-dialog', 'app-common/view/base', 'app-common/component/api-call', 'template/balance-checker/landing.htm', 'template/balance-checker/add.htm', 'template/balance-checker/overview.htm', 'template/balance-checker/overview_row.htm', 'common/lib/date', 'common/lib/jquery.hotkeys'], function($, _, _s, core, infiniteScrolling, loader, moneyFormatter, dateFormatter, confirmDialog, BaseView, apiCall, landingTemplate, addTemplate, overviewTemplate, overviewRowTemplate) {
  var BalanceCheckerPage;
  return BalanceCheckerPage = (function(_super) {
    var isLeapYear, isLedgerDateActive, yearMonthGetFullYear;

    __extends(BalanceCheckerPage, _super);

    function BalanceCheckerPage() {
      BalanceCheckerPage.__super__.constructor.apply(this, arguments);
    }

    BalanceCheckerPage.prototype.pageId = 'balance-checker';

    BalanceCheckerPage.prototype.events = {
      'click #prev-year': 'prevYear',
      'click #next-year': 'nextYear',
      'click td.actions .ss-delete': 'showDeleteRow',
      'click .ss-plus': 'showAddRow',
      'click .refresh-year-ledger-balance': 'refreshYearLedgerBalance',
      'click .reload-page': 'reloadPage',
      'click #delete-all-balances': 'deleteAllBalances',
      'click .go-to-month': 'navigateToMonthlyResults',
      'click #toggle-inactive': 'toggleInactive'
    };

    BalanceCheckerPage.prototype.year = null;

    BalanceCheckerPage.prototype.ledgers = {};

    BalanceCheckerPage.prototype.ledgerData = {};

    BalanceCheckerPage.prototype.showInactive = false;

    BalanceCheckerPage.prototype.balances = [];

    BalanceCheckerPage.prototype.ledgerAccounts = [];

    BalanceCheckerPage.prototype.fetchEntries = 30;

    BalanceCheckerPage.prototype.lastResultSize = null;

    BalanceCheckerPage.prototype.filterLedger = null;

    BalanceCheckerPage.prototype.initialize = function(options, params) {
      var isOverviewPage, promise,
        _this = this;
      BalanceCheckerPage.__super__.initialize.apply(this, arguments);
      isOverviewPage = params.length === 0;
      this.clientModel = core.getModel('client');
      promise = apiCall('balancechecker', "" + (this.clientModel.get('id')) + "/lastBalanceCheckedDate");
      return promise.done(function(year) {
        _this.year = parseInt(year);
        core.getCollection('ledgerAccounts').filter(function(ledgerAccount) {
          return ledgerAccount.isBankOrCreditCardAccount();
        }).forEach(function(ledgerAccount) {
          return _this.ledgers[ledgerAccount.get('id')] = ledgerAccount.toJSON();
        });
        if (isOverviewPage) {
          _this.render(_.template(overviewTemplate));
          $('#toggle-inactive').toggleClass('active', _this.showInactive);
          return _this.loadingPromise = _this.loadOverviewData(_this.year);
        } else {
          _this.filterLedger = params[0];
          _this.filterYear = params[1];
          _this.filterMonth = params[2];
          _this.fetchEntries = 1000;
          _this.render(landingTemplate);
          _this.setupShortCuts();
          _this.initTable('#balance_checker_widget');
          return _this.loadingPromise = _this.loadData(1);
        }
      });
    };

    /* Overview page
    */


    BalanceCheckerPage.prototype.changeYear = function(changeAmount) {
      this.year += changeAmount;
      return this.loadOverviewData(this.year);
    };

    BalanceCheckerPage.prototype.prevYear = function() {
      return this.changeYear(-1);
    };

    BalanceCheckerPage.prototype.nextYear = function() {
      return this.changeYear(1);
    };

    BalanceCheckerPage.prototype.createPolling = function() {
      var _this = this;
      if (this.pollingInterval) {
        this.clearPolling();
      }
      return this.pollingInterval = setInterval(function() {
        return _this.checkForPendingBalances();
      }, 1000);
    };

    BalanceCheckerPage.prototype.clearPolling = function() {
      return clearInterval(this.pollingInterval);
    };

    BalanceCheckerPage.prototype.checkForPendingBalances = function() {
      var promise,
        _this = this;
      promise = apiCall('balancechecker', "" + (this.clientModel.get('id')) + "?page=1&resultsPerPage=" + this.fetchEntries + "&year=" + this.filterYear);
      return promise.done(function(data) {
        var hasPending;
        hasPending = _.some(_this.filterVisibleData(data.balances), function(entry) {
          return entry.balanceMatchType === 'PENDING';
        });
        if (!hasPending) {
          _this.clearPolling();
          return _this.refreshTable();
        }
      });
    };

    BalanceCheckerPage.prototype.setupShortCuts = function() {
      var _this = this;
      $(document).on('keydown.balance_checker', null, "+", function() {
        return _this.showAddRow();
      });
      return $(document).on('keydown.balance_checker', '#add-ledger input', 'shift+return', function(e) {
        e.preventDefault();
        return $('.confirm-ok').click();
      });
    };

    BalanceCheckerPage.prototype.addOverviewRow = function(ledgerId, year) {
      var ledgerMonths;
      ledgerMonths = this.ledgerData[ledgerId];
      if (ledgerMonths == null) {
        ledgerMonths = {};
      }
      return $('#overview-content-wrapper').append(_.template(overviewRowTemplate, {
        ledgerName: this.ledgers[ledgerId].name,
        ledgerId: ledgerId,
        ledgerActive: this.ledgers[ledgerId].accountSettings.dateActive,
        ledgerInactive: this.ledgers[ledgerId].accountSettings.dateInactive,
        ledgerRole: this.ledgers[ledgerId].role,
        detailsLink: core.getRouter().buildUrl('balance-checker', [ledgerId, year]),
        ledgerMonths: ledgerMonths,
        moneyFormatter: moneyFormatter,
        year: year,
        core: core
      }));
    };

    BalanceCheckerPage.prototype.remove = function() {
      BalanceCheckerPage.__super__.remove.apply(this, arguments);
      $(document).off('keydown.balance_checker');
      return this.clearPolling();
    };

    isLeapYear = function(year) {
      return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    };

    yearMonthGetFullYear = function(dateString) {
      var parts, year;
      if (!dateString) {
        return null;
      }
      parts = dateString.split('-');
      year = parseInt(parts[0]);
      return year;
    };

    isLedgerDateActive = function(ledger, currentDateYear) {
      var dateActiveYear, dateInactiveYear;
      if (!ledger.active) {
        return false;
      }
      dateActiveYear = yearMonthGetFullYear(ledger.accountSettings.dateActive);
      dateInactiveYear = yearMonthGetFullYear(ledger.accountSettings.dateInactive);
      if (dateActiveYear && currentDateYear < dateActiveYear) {
        return false;
      }
      if (dateInactiveYear && currentDateYear > dateInactiveYear) {
        return false;
      }
      return true;
    };

    BalanceCheckerPage.prototype.refreshOverviewTable = function(year) {
      var ledgerChain,
        _this = this;
      $('#overview-content-wrapper').empty();
      $("#current-year").html(year);
      $('#toggle-inactive').toggleClass('active', this.showInactive);
      if (_.isEmpty(this.ledgers)) {
        return $('#overview-content-wrapper').html('<div class="not-found">There are no results for selected period</div>');
      } else {
        ledgerChain = _.chain(this.ledgers).map(function(ledger, ledgerId) {
          return _.extend({}, ledger, {
            id: ledgerId
          });
        });
        if (!this.showInactive) {
          ledgerChain = ledgerChain.filter(function(ledger) {
            return isLedgerDateActive(ledger, year);
          });
        }
        return ledgerChain.sortBy(function(ledger) {
          return [!isLedgerDateActive(ledger, year), ledger.categoryId || 0, ledger.order || 0];
        }).each(function(ledger) {
          return _this.addOverviewRow(ledger.id, year);
        }).value();
      }
    };

    BalanceCheckerPage.prototype.navigateToMonthlyResults = function(e) {
      var data, linkledgerAccountId, linkmonth, linkyear;
      data = $(e.currentTarget).data('id').split('-');
      linkledgerAccountId = data[0];
      linkyear = data[1];
      linkmonth = data[2];
      return core.getRouter().loadPage('balance-checker', [linkledgerAccountId, linkyear, linkmonth]);
    };

    BalanceCheckerPage.prototype.loadOverviewData = function(year) {
      var promise,
        _this = this;
      loader.init();
      promise = apiCall('balancechecker', "" + (this.clientModel.get('id')) + "?year=" + year);
      promise.always(function() {
        return loader.hide();
      });
      return promise.done(function(data) {
        _this.ledgerData = {};
        _.each(data.monthlyBalances, function(monthlyResults, ledgerId) {
          return _.each(monthlyResults, function(result, month) {
            var ledgerAccountId, _base, _ref;
            ledgerAccountId = result.clientLedgerAccountId;
            if ((_ref = (_base = _this.ledgerData)[ledgerAccountId]) == null) {
              _base[ledgerAccountId] = {};
            }
            return _this.ledgerData[ledgerAccountId][month] = result;
          });
        });
        return _this.refreshOverviewTable(year);
      });
    };

    /* Detailed page
    */


    BalanceCheckerPage.prototype.fixDatepicker = function() {
      $('.modal').removeClass('fixed');
      return _.extend($.datepicker, {
        _checkOffset: function(inst, offset, isFixed) {
          return offset;
        }
      });
    };

    BalanceCheckerPage.prototype.getBalanceRow = function(id) {
      return $('#balance-id-' + id);
    };

    BalanceCheckerPage.prototype.getBalanceData = function(id) {
      return _.findWhere(this.balances, {
        pageId: id
      });
    };

    BalanceCheckerPage.prototype.getLedgerAccount = function(id) {
      return _.findWhere(this.ledgerAccounts, {
        clientLedgerAccountId: id
      });
    };

    BalanceCheckerPage.prototype.getIdByBalanceRow = function(row) {
      return $(row).attr('id').replace('balance-id-', '');
    };

    BalanceCheckerPage.prototype.getLedgerAccountIdByElemId = function(e) {
      return e.attr('id').replace('ledger-id-', '');
    };

    BalanceCheckerPage.prototype.isHidden = function(ledgerAccountId, date) {
      if (this.filterLedger && this.filterLedger !== ledgerAccountId) {
        return true;
      } else if (this.filterYear && parseInt(this.filterYear) !== date.getFullYear()) {
        return true;
      } else if (this.filterMonth && this.filterMonth !== core.formatMonth(date.getMonth())) {
        return true;
      } else {
        return false;
      }
    };

    BalanceCheckerPage.prototype.showAddRow = function() {
      var template,
        _this = this;
      template = _.template(addTemplate, {
        ledgers: this.ledgers,
        selectedLedger: this.filterLedger
      });
      confirmDialog.init(template, {
        ok: 'Add Balance',
        cancel: 'Cancel'
      }, true);
      this.fixDatepicker();
      $('#balance-date').datepicker({
        maxDate: '+0d',
        minDate: new Date(2005, 0, 1)
      }).val("" + this.filterMonth + "/01/" + this.filterYear);
      $('#balance-date').select();
      $('#balance-date').click(function() {
        return $('#balance-date').select();
      });
      $('#balance-date').change(function() {
        var date, value;
        value = $('#balance-date').val();
        value = core.formatYearCorrectly(value);
        date = Date.parse(value);
        if (date === null || value.length < 6 || value.length > 10) {
          date = new Date();
        }
        return $('#balance-date').val(core.formatDate(date));
      });
      $('#balance-value').change(function() {
        var moneyAmount, result, value;
        value = $('#balance-value').val();
        moneyAmount = parseFloat(moneyFormatter.unformat(value));
        result = isNaN(moneyAmount) ? result = '0.00' : result = moneyFormatter.formatNumber(moneyAmount);
        return $('#balance-value').val(result);
      });
      return $('.confirm-ok').on('click', function() {
        var balance, balanceDate, balanceDateString, existedRow, ledgerAccountId, promise, restMethod;
        loader.init({
          modal: true
        });
        ledgerAccountId = $('#ledger-account').val();
        balanceDate = $('#balance-date').datepicker('getDate');
        balanceDateString = balanceDate.toString('MMM dd yyyy');
        balance = parseFloat(moneyFormatter.unformat($('#balance-value').val()));
        existedRow = _.find(_this.balances, function(entry) {
          if (entry.balanceDateString === balanceDateString && entry.clientLedgerAccountId === ledgerAccountId) {
            return true;
          }
        });
        restMethod = existedRow != null ? 'PUT' : 'POST';
        promise = apiCall('balancechecker', "" + (_this.clientModel.get('id')) + "/" + ledgerAccountId + "/" + balanceDateString, restMethod, {
          balance: balance
        });
        return promise.done(function() {
          var _ref;
          loader.hide();
          confirmDialog.hide();
          _this.addRow({
            clientLedgerAccountId: ledgerAccountId,
            clientLedgerAccountName: (_ref = _this.ledgers[ledgerAccountId]) != null ? _ref.name : void 0,
            balanceDate: balanceDate,
            balanceDateString: balanceDateString,
            balance: balance,
            balanceMatchType: null,
            lastCheckTimeMillis: null
          });
          if (!_this.isHidden(ledgerAccountId, balanceDate)) {
            _this.refreshTable();
            _this.createPolling();
          }
          return _this.sortTableByTime();
        });
      });
    };

    BalanceCheckerPage.prototype.filterVisibleData = function(ledgerBalanceEntries) {
      var _this = this;
      return _.reject(ledgerBalanceEntries, function(entry) {
        return _this.isHidden(entry.clientLedgerAccountId, Date.parse(entry.balanceDate));
      });
    };

    BalanceCheckerPage.prototype.addRows = function(ledgerBalanceEntries) {
      var entry, _i, _len, _ref, _results;
      _ref = this.filterVisibleData(ledgerBalanceEntries);
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        entry = _ref[_i];
        _results.push(this.addRow(entry));
      }
      return _results;
    };

    BalanceCheckerPage.prototype.addRow = function(entry) {
      var date;
      date = Date.parse(entry.balanceDate);
      entry.pageId = _.uniqueId();
      entry.balanceDateMillis = date.getTime();
      if (this.isHidden(entry.clientLedgerAccountId, date)) {
        return;
      }
      this.balances.push(entry);
      return this.datatable.fnAddData(entry);
    };

    BalanceCheckerPage.prototype.showDeleteRow = function(e) {
      var row,
        _this = this;
      row = $(e.currentTarget).closest('.balance-row');
      confirmDialog.init('Are you sure you want to delete this Balance?', {
        ok: 'Delete Balance',
        cancel: 'Cancel'
      });
      return $('.confirm-ok').on('click', function() {
        var balanceData, balanceId, promise;
        loader.init({
          modal: true
        });
        balanceId = _this.getIdByBalanceRow(row);
        balanceData = _this.getBalanceData(balanceId);
        promise = apiCall('balancechecker', "" + (_this.clientModel.get('id')) + "/" + balanceData.clientLedgerAccountId + "/" + balanceData.balanceDateString, 'DELETE');
        return promise.done(function() {
          loader.hide();
          confirmDialog.hide();
          return _this.deleteRow(balanceId);
        });
      });
    };

    BalanceCheckerPage.prototype.refreshYearLedgerBalance = function(e) {
      var ledgerId, promise,
        _this = this;
      ledgerId = this.getLedgerAccountIdByElemId($(e.currentTarget));
      promise = apiCall('balancechecker', "" + (this.clientModel.get('id')) + "/" + ledgerId + "/" + this.year + "/refresh-year", 'PUT');
      return promise.done(function() {
        return _this.loadOverviewData(_this.year);
      });
    };

    BalanceCheckerPage.prototype.reloadPage = function() {
      return this.loadOverviewData(this.year);
    };

    BalanceCheckerPage.prototype.deleteRow = function(id) {
      var row,
        _this = this;
      row = this.getBalanceRow(id);
      return $(row).fadeOut('slow', function() {
        _this.balances = _.reject(_this.balances, function(balance) {
          return balance.pageId === id;
        });
        return _this.datatable.fnDeleteRow(row[0]);
      });
    };

    BalanceCheckerPage.prototype.refreshTable = function() {
      this.datatable.fnClearTable();
      this.balances = [];
      this.loadData(1);
      return setTimeout(infiniteScrolling.refreshSettings, 50);
    };

    BalanceCheckerPage.prototype.loadData = function(page) {
      var promise,
        _this = this;
      loader.init();
      promise = apiCall('balancechecker', "" + (this.clientModel.get('id')) + "?page=" + page + "&resultsPerPage=" + this.fetchEntries + "&year=" + this.filterYear);
      return promise.done(function(data) {
        loader.hide();
        infiniteScrolling.afterLoad();
        _this.lastResultSize = data.balances.length;
        return _this.addRows(data.balances);
      });
    };

    BalanceCheckerPage.prototype.sortTableByTime = function() {
      return this.datatable.fnSort([[7, 'desc']]);
    };

    BalanceCheckerPage.prototype.initTable = function(element) {
      return this.datatable = $(element).find('table').dataTable({
        aoColumnDefs: [
          {
            aTargets: [0],
            sTitle: 'Ledger',
            mData: 'clientLedgerAccountName',
            sClass: 'ledger',
            sWidth: '30%'
          }, {
            aTargets: [1],
            sTitle: 'Date',
            mData: 'balanceDateString',
            sClass: 'date-column',
            sWidth: '12%',
            mRender: function(data) {
              var dateArr;
              dateArr = data.split(' ');
              return ("<span class='month-day'>" + dateArr[0] + " " + dateArr[1] + "</span><br />") + ("<span class='year'>" + dateArr[2] + "</span>");
            }
          }, {
            aTargets: [2],
            sTitle: 'Balance',
            mData: 'balance',
            sClass: 'balance',
            sType: 'money',
            sWidth: '12%',
            mRender: function(data) {
              return moneyFormatter.formatNumber(data);
            }
          }, {
            aTargets: [3],
            sTitle: 'Match',
            mData: null,
            sClass: 'match',
            sWidth: '12%',
            mRender: function(data, type, full) {
              if ((full.balanceMatchType == null) || full.balanceMatchType === 'PENDING') {
                return 'Pending';
              } else if (full.balanceMatchType === 'NO_MATCH') {
                return "<span class='warning'>" + (full.calculatedBalance ? moneyFormatter.formatNumber(full.calculatedBalance) : '') + "</span>";
              } else {
                return 'Yes';
              }
            }
          }, {
            aTargets: [4],
            sTitle: 'Time of Match',
            mData: 'balanceMatchType',
            sClass: 'match-time',
            sWidth: '15%',
            mRender: function(data) {
              switch (data) {
                case 'BEFORE':
                  return 'Before';
                case 'AFTER':
                  return 'After';
                case 'DURING':
                  return 'During';
                default:
                  return '';
              }
            }
          }, {
            aTargets: [5],
            sTitle: 'Last check',
            mData: 'lastCheckTimeMillis',
            sClass: 'last-check',
            sWidth: '14%',
            mRender: function(data) {
              if (data) {
                return dateFormatter.timeAgo(data / 1000, {
                  shortMonth: true
                });
              } else {
                return '';
              }
            }
          }, {
            aTargets: [6],
            sTitle: '<span class="ss-plus ss-standard"></span>',
            mData: null,
            sClass: 'actions',
            sWidth: '5%',
            mRender: function() {
              return '<span class="ss-delete ss-standard"></span>';
            }
          }, {
            aTargets: [7],
            mData: 'balanceDateMillis',
            bVisible: false
          }
        ],
        fnRowCallback: function(row, data) {
          if ($(row).hasClass('balance-row')) {
            return row;
          }
          $(row).attr('id', 'balance-id-' + data.pageId).addClass('balance-row');
          return row;
        },
        bInfo: false,
        bLengthChange: false,
        bFilter: false,
        bPaginate: false,
        bAutoWidth: false,
        bSort: false
      });
    };

    BalanceCheckerPage.prototype.deleteAllBalances = function() {
      var _this = this;
      confirmDialog.init("Do you want to delete all balances?", {
        ok: 'Delete',
        cancel: 'Cancel'
      }, true);
      return $('.confirm-ok').on('click', function() {
        var request;
        request = apiCall('balancechecker', "" + (_this.clientModel.get('id')) + "/" + _this.filterLedger + "/" + _this.filterYear + "/" + _this.filterMonth, 'DELETE');
        loader.init({
          modal: true
        });
        return request.always(function() {
          loader.hide();
          confirmDialog.hide();
          return _this.refreshTable();
        });
      });
    };

    BalanceCheckerPage.prototype.toggleInactive = function() {
      this.showInactive = !this.showInactive;
      $('#toggle-inactive').toggleClass('active', this.showInactive);
      return this.refreshOverviewTable(this.year);
    };

    return BalanceCheckerPage;

  })(BaseView);
});
